module.exports = __webpack_public_path__ + "img/11_non_L1.bfe4b165.svg";